import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { TerfaShadowSniperFlyOverlay } from './TerfaShadowSniperFlyOverlay';

/**
 * Flies three Shadow Snipers from Ter'fa to the player profile one after another.
 */
export const TerfaShadowSniperFlyBatchOverlay = ({
  grant,
  orders,
  cardScale = 1,
  mobileOuterScale = 1,
  isMobileHand = false,
  gameState = null,
  userId = null,
  onComplete,
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const onCompleteRef = useRef(onComplete);
  const batchFinishedRef = useRef(false);

  useLayoutEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const batchGrants = grant?.batchGrants;
  const currentGrant = batchGrants?.[stepIndex];
  const currentOrder = orders?.[stepIndex];

  const handleStepComplete = useCallback(() => {
    if (!batchGrants?.length) {
      return;
    }
    setStepIndex((prev) => {
      if (prev + 1 >= batchGrants.length) {
        if (!batchFinishedRef.current) {
          batchFinishedRef.current = true;
          onCompleteRef.current?.();
        }
        return prev;
      }
      return prev + 1;
    });
  }, [batchGrants]);

  if (!grant || !batchGrants?.length || !currentGrant || !currentOrder) {
    return null;
  }

  return (
    <TerfaShadowSniperFlyOverlay
      key={`${grant.key}-step-${stepIndex}-${currentGrant.orderInstanceId}`}
      grant={currentGrant}
      order={currentOrder}
      cardScale={cardScale}
      mobileOuterScale={mobileOuterScale}
      isMobileHand={isMobileHand}
      gameState={gameState}
      userId={userId}
      onComplete={handleStepComplete}
    />
  );
};
